import { render, staticRenderFns } from "./index_content.vue?vue&type=template&id=634ea7ea&scoped=true&"
import script from "./index_content.vue?vue&type=script&lang=js&"
export * from "./index_content.vue?vue&type=script&lang=js&"
import style0 from "./index_content.vue?vue&type=style&index=0&id=634ea7ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ea7ea",
  null
  
)

export default component.exports